module.exports = __webpack_public_path__ + "static/media/close_white.f6bbff26.svg";